import axios from "axios";
import Config from "../utils/Config";

const BASE_URL = Config.apiUrl;

class ConferenceAndTradeMission {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_agt_tk")}`,
      },
    };
  }

  getGuestHeaders() {
    return {
      headers: { "Content-Type": "application/json" },
    };
  }

  async getConferenceAndTradeMission() {
    try {
      const response = await axios.get(
        `${BASE_URL}/events/conferences`,
        this.getGuestHeaders()
      );
      const body = response.data?.data ?? response.data;
      const list = Array.isArray(body?.data) ? body.data : (Array.isArray(body) ? body : []);
      return {
        status: true,
        data: body,
        list,
        message: body?.reason || "Conference and trade mission fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        list: [],
        message:
          error.response?.data?.message ||
          error.response?.data?.reason ||
          "An error occurred while fetching conferences and trade missions",
      };
    }
  }

  async getEventDetails(eventSlug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/events/get/${eventSlug}`,
        this.getGuestHeaders()
      );
      // API shape: { data: { status_code, message, reason, data: { event, similar_event }, point_in_time } }
      const outer = response.data?.data ?? response.data;
      const inner = outer?.data ?? outer;
      const event = inner?.event ?? inner;
      const similar_event = inner?.similar_event ?? [];
      return {
        status: true,
        data: inner,
        event,
        similar_event,
        message: outer?.message ?? response.data?.message ?? "Event details fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        event: null,
        similar_event: [],
        message:
          error.response?.data?.message ||
          error.response?.data?.reason ||
          "An error occurred while fetching event details",
      };
    }
  }

  async registerTradeMission(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/events/create`,
        payload,
        this.getAuthHeaders()
      );
      const body = response.data?.data ?? response.data;
      const ok = response.data?.status_code === 200 || response.status === 200;
      return {
        status: ok,
        data: body,
        message: body?.reason ?? response.data?.message ?? "Event registration submitted successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.message ||
          error.response?.data?.reason ||
          "An error occurred while submitting registration",
      };
    }
  }

  /**
   * Agent-specific endpoint for creating event registrations (e.g. trade mission).
   * POST https://api.tripsecuregh.com/api/agent/events/create
   */
  async createAgentEvent(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/agent/events/create`,
        payload,
        this.getAuthHeaders()
      );
      const body = response.data?.data ?? response.data;
      const ok = response.data?.status_code === 200 || response.status === 200;
      return {
        status: ok,
        data: body,
        message: body?.reason ?? response.data?.message ?? "Event registration submitted successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.message ||
          error.response?.data?.reason ||
          "An error occurred while submitting registration",
      };
    }
  }
}

const conferenceAndTradeMissionService = new ConferenceAndTradeMission();
export default conferenceAndTradeMissionService;
